import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"
import favicon from '../images/fav.ico'
import { Helmet } from "react-helmet"


export const SEO = ({ title, description, keywords, pathname, image, children }) => {
  const { title: defaultTitle, description: defaultDescription, keywords: defaultKeywords, image: defaultImage, siteUrl  } = useSiteMetadata()
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    keywords: keywords || defaultKeywords,
    image: image?.startsWith("http") ? image : `${siteUrl}${image || defaultImage}`, 
    url: `${siteUrl}${pathname || ''}`,
  };

  
  
  
  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords}/>
      <meta name="image" content={seo.image} />
      
      <meta property="og:card" content="summary_large_image" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:keywords" content={seo.keywords}/>
      <meta property="og:image" data-react-helmet="true" content={seo.image} />

    
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:keywords" content={seo.keywords}/>
      <meta name="twitter:image" content={seo.image} />
      <link rel="icon" type="image/x-icon" href={favicon}></link>
      <link rel="apple-touch-icon" type="image/x-icon" href={favicon}></link>
      {children}
    </>
  )
}